import JobCard from "../molecules/JobCard";
 
const JobListingTemplate = ({
  jobs,
  loading = false,
  errorMessage = "",
}) => {
  const list = Array.isArray(jobs) ? jobs : [];
 
  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6 space-y-10">
      {/* Hero Section */}
      <section className="flex flex-col items-center justify-center text-center bg-gradient-to-b from-yellow-50 to-white border-b border-gray-200 py-12 sm:py-20">
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight">
          <span className="text-[#FFCC00] drop-shadow-md">Y'ello</span>
          <span className="text-gray-900 ml-2">Vacancy</span>
        </h2>
      </section>
 
      {/* Job Cards */}
      <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 min-h-[400px]">
        {loading ? (
          <div className="p-6 bg-white text-center border rounded text-gray-600">
            Loading jobs...
          </div>
        ) : errorMessage ? (
          <div className="p-6 bg-white text-center border rounded text-red-600">
            {errorMessage}
          </div>
        ) : list.length === 0 ? (
          <div className="p-6 bg-white text-center border rounded text-gray-600">
            No jobs available yet.
          </div>
        ) : (
          list.map((job, i) => <JobCard key={i} job={job} />)
        )}
      </section>
    </div>
  );
};
 
export default JobListingTemplate;